import { EsInventoryModel, InventoryModel } from "../models"
import { isAdmin } from "./account"
import client from "./base"

export type IGetInventoryItems = {
    adminId: string,
    pharmacyId: string,
    filter: {
        offset: number,
        limit: number,
        skip: number,
        order: string,
        where?: {
            [key: string]: {}
        },
    },
    dropShipping: string
}

export const getInventoryInPharmacy = async (params: IGetInventoryItems) => {
    const { pharmacyId, adminId, filter, dropShipping } = params

    let path = `${process.env.REACT_APP_PHARMACY_INVENTORY_API_BASE_URL}/pis/inventory-management/pharmacies/${pharmacyId}/inventory-items`

    if (isAdmin()) {
        path = `${process.env.REACT_APP_PHARMACY_INVENTORY_API_BASE_URL}/pis/inventory-management/admins/${adminId}/pharmacies/${pharmacyId}/inventory-items`
    }

    try {
        let fetchResults = await Promise.all([
            client.get(
                path + '/count',
                { params: { where: filter.where, dropShipping } }
            ),
            client.get(
                path,
                { params: { filter, dropShipping } }
            )
        ])

        let total = 0;
        let listInventory = [];

        total = fetchResults[0].data.count;
        listInventory = fetchResults[1].data.map((product: any) => {
            return {
                ...new InventoryModel({
                    ...product,
                    _id: product.mProductId,
                    name: product.mProductName
                })
            }
        })
        return {
            listInventory,
            total
        }
    } catch (err) {
        console.error("error on fetch inv items: ", err);
        return {
            listInventory: [],
            total: 0
        }
    }
}

export type IUpdatePharmacyInventoryRequest = {
    adminId: string,
    pharmacyId: string,
    listInventory: Array<{
        mId?: number;
        mCreated?: Date;
        mModified?: Date;
        mStatus?: string;
        mPharmacyId?: number;
        mProductId?: string;
        mPrice?: number;
        mStockAmount?: number;
        mPackageId?: string;
        mEsModified?: Date;
        mProductName?: string;
        mPkgName?: string;
        mCategory?: string;
    }>
}

export const updatePharmacyInventory = async (payload: IUpdatePharmacyInventoryRequest) => {
    const { adminId, pharmacyId } = payload

    let path = `${process.env.REACT_APP_PHARMACY_INVENTORY_API_BASE_URL}/pis/inventory-management/pharmacies/${pharmacyId}/inventory-items/batch`
    if (isAdmin()) {
        path = `${process.env.REACT_APP_PHARMACY_INVENTORY_API_BASE_URL}/pis/inventory-management/admins/${adminId}/pharmacies/${pharmacyId}/inventory-items/batch`
    }

    return await client.post(
        path,
        payload.listInventory,
    )
}

export interface IDeleteInventoryReq {
    adminId?: string
    pharmacyId?: string
    productId: string
}

export const deleteInventory = async ({ adminId, pharmacyId, productId }: IDeleteInventoryReq) => {
    let path = `${process.env.REACT_APP_PHARMACY_INVENTORY_API_BASE_URL}/pis/inventory-management/pharmacies/${pharmacyId}/inventory-items/products/${productId}`
    if (isAdmin()) {
        path = `${process.env.REACT_APP_PHARMACY_INVENTORY_API_BASE_URL}/pis/inventory-management/admins/${adminId}/pharmacies/${pharmacyId}/inventory-items/products/${productId}`
    }

    return await client.delete(path)
}

export const searchInventory = async (query: any): Promise<{
    data: EsInventoryModel[],
    total: number
}> => {
    return await client.post(
        `${process.env.REACT_APP_API_BASE_URL}/es/proxy/pharmacy-inventory/_search`,
        query,
        {
            headers: {
                'Content-Type': 'application/json',
            }
        }
    ).then(res => {
        return {
            data: res?.data?.hits?.hits.map((item: any) => {
                return new EsInventoryModel(item._source)
            }),
            total: res?.data?.hits?.total?.value
        }
    })
}

export const getAllPackagesInventory = async (adminId: number, pharmacyId: number) => {
    const path = `${process.env.REACT_APP_PHARMACY_INVENTORY_API_BASE_URL}/pis/inventory-management/admins/${adminId}/pharmacies/${pharmacyId}/inventory-items/all-packages`;
    return await client.get(path).then(res => {
        return res.data.map((item: any) => new InventoryModel(item));
    });
}